import React, { useContext, useState } from 'react'
import Modal from 'react-modal'
import ProcessingPayment from './ProcessingPayment'
import UserContext from '../../../../context/UserContext'
import { maskEmail } from '../../../../utils/functions/maskData'
interface IProps {
  closeConfirmPaymentModal: any
  closePaymentModal: any
  plan: any
  currentPlan: any
  cardHolderName: any
  cardNumber: any
  data: any
}

const ConfirmPayment: React.FC<IProps> = ({
  closeConfirmPaymentModal,
  closePaymentModal,
  plan,
  currentPlan,
  cardHolderName,
  cardNumber,
  data
}) => {
  const [isPaymentProcessingModalOpen, setIsPaymentProcessinModalOpen] = useState<boolean>(false)
  const { currentUser } = useContext(UserContext)

  const customModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)'
    }
  }

  const openPaymentProcessinModal = () => {
    setIsPaymentProcessinModalOpen(true)
  }

  const afterOpenPaymentProcessinModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closePaymentProcessinModal = () => {
    setIsPaymentProcessinModalOpen(false)
  }

  const today = new Date()
  const formattedDate = formatDate(today)
  function formatDate(date: any) {
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0') // Months are zero-indexed
    const year = date.getFullYear()
    return `${month}-${day}-${year}`
  }

  console.log(data)
  return (
    <div>
      <div className='card-body pt-3'>
        {/* Section */}
        <div className='mb-10'>
          {/* Title */}
          <h5 className='mb-4'>Confirm Your Payment</h5>
          <span className='text-muted mt-1 fw-bold fs-7'>
            Quickly and secure free transactions.
          </span>

          {/* Details */}
          <div className='d-flex flex-wrap py-5'>
            {/* Row */}
            <div className='flex-equal me-5'>
              {/* Details */}
              <hr />
              <table className='table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0'>
                <tbody>
                  <h5>Details</h5>
                  <tr>
                    <td className='text-gray-500 min-w-175px w-175px'>Date:</td>
                    <td className='text-gray-800 min-w-200px'>
                      <div className='text-gray-800 text-hover-primary'>{formattedDate}</div>
                    </td>
                  </tr>
                  <tr>
                    <td className='text-gray-500'>Payment Method:</td>
                    <td className='text-gray-800'>Visa</td>
                  </tr>
                  <tr>
                    <td className='text-gray-500'>Card Number:</td>
                    <td className='text-gray-800'>{cardNumber}</td>
                  </tr>
                  <tr>
                    <td className='text-gray-500'>CardHolder Name:</td>
                    <td className='text-gray-800'>{cardHolderName}</td>
                  </tr>
                  <tr>
                    <td className='text-gray-500'>Email:</td>
                    <td className='text-gray-800'>
                      {' '}
                      {!!currentUser ? maskEmail(currentUser.email) : 'abc@xyz.com'}
                    </td>
                  </tr>
                </tbody>
              </table>
              <hr />
              <table className='table fs-6 fw-semibold gs-0 gy-2 gx-2 m-0'>
                <tbody>
                  <tr>
                    <td className='text-gray-500 min-w-175px w-175px'>Total Amount:</td>
                    <td className='text-gray-800 min-w-200px'>
                      <div className='text-gray-800 fw-bold text-hover-primary mb-1 fs-6'>
                        {data?.getAmountForSelectedPlan?.data}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* Row */}
          </div>
          <div className='text-end '>
            <button
              id='kt_modal_new_card_cancel'
              className='btn btn-light me-3'
              onClick={closeConfirmPaymentModal}
            >
              Cancel Payment
            </button>
            <button
              type='submit'
              id='kt_modal_new_card_submit'
              className='btn btn-primary'
              onClick={openPaymentProcessinModal}
            >
              <span className='indicator-label'>Confirm Payment</span>
              <span className='indicator-progress'>
                Please wait...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <Modal
        isOpen={isPaymentProcessingModalOpen}
        onAfterOpen={afterOpenPaymentProcessinModal}
        onRequestClose={closePaymentProcessinModal}
        style={customModalStyles}
        contentLabel='Payment Processing'
      >
        <ProcessingPayment
          closePaymentProcessingModal={closePaymentProcessinModal}
          closeConfirmPaymentModal={closeConfirmPaymentModal}
          closePaymentModal={closePaymentModal}
          plan={plan}
          data={data}
        />
      </Modal>
    </div>
  )
}

export default ConfirmPayment
